<script lang="ts">
  import { m } from "#messages";

  let { size = 16 }: { size?: number } = $props();
</script>

<svg
  role="status"
  aria-label={m.ui_loading()}
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  class="animate-spin"
>
  <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="2" opacity="0.25" />
  <path
    d="M14.5 8a6.5 6.5 0 0 0-6.5-6.5"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
